import React, { useState, useContext } from 'react';
import { Input, Button, message, Card, Form } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';
import { useNavigate } from 'react-router-dom';
import './login.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const { login } = useContext(LoginContext);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/usuarios/login`, {
        user: credentials.user,
        password: credentials.password,
      });

      const { usuario, token } = response.data;

      login({ ...usuario, token }); // Guardar todos los datos del usuario en el contexto

      // Limpiar empresa seleccionada al iniciar sesión
      localStorage.removeItem('empresaSeleccionada');

      // Redirigir según el tipo de usuario
      switch (usuario.tiu_descripcion) {
        case 'Administrador':
          navigate('/select-empresa'); // Siempre redirigir a selección de empresa para administradores
          break;
        case 'Empresa':
          navigate('/home-empresa'); // Ruta para empresa
          break;
        case 'Empleado':
          navigate('/home-empleado'); // Ruta para empleado
          break;
        default:
          message.error('Tipo de usuario no reconocido');
      }
    } catch (error) {
      message.error('Credenciales incorrectas');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Card style={{ width: 350, margin: '100px auto' }}>
      {/* Logo */}
      <div style={{ textAlign: 'center' }}>
        <img src="/logo-genosoftware.png" alt="Logo" style={{ width: '250px' }} />
      </div>
      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input
            placeholder="Usuario"
            value={credentials.user}
            onChange={(e) => setCredentials({ ...credentials, user: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Contraseña"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Iniciar sesión
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Login;